import styled from 'styled-components'

export const StyledContainer = styled.div``

export const StyledTitleContainer = styled.div`
	display: grid;
	justify-items: center;
	grid-row-gap: 23px;
	margin-bottom: 20px;
`

export const StyledMainContainer = styled.div`
	margin-top: 30px;
	display: block;
	padding: 0 30px;
	.slick-slide {
		margin: 0 !important;
	}
`

export const StyledInnerContainer = styled.div`
	width: max-content;
	position: relative;
	top: 0;
	transition: all ease 5s;
`

export const StyledImageContainer = styled.div`
	display: grid;
	align-items: center;
	justify-items: center;
`

export const StyledArrowButton = styled.div`
	cursor: pointer;
	background: none;
`
